var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmexIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3242 20.5947L28.9044 18.8933L27.43 20.5947H24.5358H18.3106V12.6747H15.4164L19.0205 3.816H22.5154L23.7713 6.86667V3.816H28.1399L28.9044 6.104L29.6689 3.816H33V2.46667C33 1.64533 32.3993 1 31.6348 1H2.36519C1.60068 1 1 1.64533 1 2.46667V21.5333C1 22.3547 1.60068 23 2.36519 23H31.6348C32.3993 23 33 22.3547 33 21.5333V20.5947H30.3242Z",
    fill: "#0071CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7041 19.6609H32.9976L29.9942 16.1995L32.9976 12.7969H30.7587L28.8474 15.0262L26.9908 12.7969H24.6973L27.7553 16.2582L24.6973 19.6609H26.9362L28.8474 17.4315L30.7041 19.6609Z",
    fill: "#0071CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0385 18.0769V17.0209H24.6426V15.4369H21.0385V14.3809H24.6972V12.7969H19.291V19.6609H24.6972V18.0769H21.0385Z",
    fill: "#0071CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3048 11.7977H32.943V4.875L30.3218 4.93367L28.902 9.21633L27.4276 4.93367H24.6973V11.7977H26.4447V6.987L28.0829 11.7977H29.6119L31.3048 6.987V11.7977Z",
    fill: "#0071CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9125 4.93359H19.6736L16.834 11.7976H18.7452L19.2913 10.4483H22.2401L22.7862 11.7976H24.7521L21.9125 4.93359ZM19.892 8.86426L20.7657 6.63493L21.6394 8.86426H19.892Z",
    fill: "#0071CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.416 16.018L32.9996 17.8953V14.1406L31.416 16.018Z",
    fill: "#0071CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexIcon);
export default __webpack_public_path__ + "static/media/AmexIcon.3389a4e26d22bc5efbb79a94d383fe46.svg";
export { ForwardRef as ReactComponent };